<section class="container-wrapper">
    <h1 class="module-heading">
      {{ 'pages.userFamily.list.heading.my-family' | translate }}
    </h1>
    <div class="loading-spinner" *ngIf="loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20">
      </mat-progress-spinner>
    </div>
    <div class="module-content" *ngIf="!loading">
      <div class="list-wrapper">
        <div *ngFor="let link of activeLinks">
          <app-family-member 
            *ngIf="!link.deleted"
            [link]="link"
            (handleEdit)="openEditFamilyLinkDialog($event)"
            (handleDelete)="openRemoveFamilyConfirmDialog($event)"
          ></app-family-member>
        </div>
        <!-- <div>
          <button class="bciti-inline-button" (click)="openCreateCardDialog(profile)">
            <span class="icon-circle-plus button-icon"></span>
            <span class="mls">{{ 'pages.userFamily.list.add' | translate }}</span>
          </button>
        </div> -->
      </div>
      <div class="list-wrapper">
        <h3 class="margin-top">{{ 'pages.userFamily.list.heading.my-family-invite' | translate }}</h3>
        <div *ngFor="let link of pendingInvitationLinks">
          <app-family-member
            *ngIf="!link.deleted"
            [link]="link"
            (handleForceAccept)="openForceAcceptFamilyLinkDialog($event)"
          ></app-family-member>
        </div>
      </div>
      <div class="list-wrapper">
        <h3 class="margin-top">{{ 'pages.userFamily.list.heading.my-family-pending' | translate }}</h3>
        <div *ngFor="let link of pendingApprovalLinks">
          <app-family-member
            *ngIf="!link.deleted"
            [link]="link"
          ></app-family-member>
        </div>
      </div>
    </div>
  </section>